import React from 'react';
import { Link } from 'react-router-dom';
import { useConsent } from '@/contexts/ConsentContext';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { openModal } = useConsent();

  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-lg font-semibold text-foreground mb-4">CoachSim</h3>
            <p className="text-muted-foreground mb-4 max-w-md">
              Advanced AI-powered coaching simulation platform for professionals seeking to enhance their coaching skills through realistic roleplay and structured feedback.
            </p>
            <div className="flex space-x-4">
              <span className="text-muted-foreground text-sm">
                Contact us through our in-app support system
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-foreground text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-muted-foreground hover:text-foreground text-sm">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/subscription" className="text-muted-foreground hover:text-foreground text-sm">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/account" className="text-muted-foreground hover:text-foreground text-sm">
                  Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal & Documentation */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Legal & Documentation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/product-specification" className="text-muted-foreground hover:text-foreground text-sm">
                  Product Specification
                </Link>
              </li>
              <li>
                <a href="/privacy-policy" className="text-muted-foreground hover:text-foreground text-sm">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms-of-service" className="text-muted-foreground hover:text-foreground text-sm">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="/gdpr-policy" className="text-muted-foreground hover:text-foreground text-sm">
                  GDPR Compliance
                </a>
              </li>
              <li>
                <button
                  onClick={openModal}
                  className="text-muted-foreground hover:text-foreground text-sm bg-transparent border-none cursor-pointer p-0 text-left"
                >
                  Cookie Preferences
                </button>
              </li>
              <li>
                <Link to="/unsubscribe" className="text-muted-foreground hover:text-foreground text-sm">
                  Unsubscribe
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-border mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-muted-foreground text-sm">
              © {currentYear} CoachSim. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <span className="text-muted-foreground text-xs">
                Built with ethical AI principles
              </span>
              <span className="text-muted-foreground text-xs">
                ISO 27001 Compliant
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 